module.exports = __webpack_public_path__ + "static/img/home_img_3.6aadded.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_img_3.png
// module id = FfOb
// module chunks = 0